<!-- src/App.vue -->
<template>
  <div id="app">
    <div class="main-container" v-if="isLoggedIn">
      <!-- 移动端菜单切换按钮 -->
      <div class="mobile-menu-button" v-if="isMobile" @click="toggleMenu">
        <i :class="isMenuHidden ? 'el-icon-menu' : 'el-icon-close'" class="menu-icon"></i>
      </div>
      
      <!-- 遮罩层 -->
      <div
        class="menu-overlay"
        :class="{ 'show': isMobile && !isMenuHidden }"
        @click="toggleMenu"
        v-if="isMobile"
      ></div>

      <!-- 左侧菜单栏 -->
      <div class="menu-wrapper" :class="{ 'mobile-menu-hidden': isMobile && isMenuHidden }">
        <el-menu
          default-active="2"
          class="el-menu-vertical-demo custom-menu"
          :collapse="isCollapse"
          background-color="#2c3e50"
          text-color="#ecf0f1"
          active-text-color="#ffd04b"
        >
         <el-menu-item
  v-for="(link, index) in encryptedNavLinks"
  :key="index"
  :index="index.toString()"
  @click="navigateTo(decodePath(link.path))"
  class="custom-menu-item"
>
  <i class="el-icon-menu"></i>

  {{ link.text }}

</el-menu-item>

        </el-menu>
      </div>

      <!-- 右侧内容区域 -->
      <div class="right-content">
        <div class="content-header">
          <div class="user-info">
            <img src="@/assets/default-avatar.png" alt="Default Avatar" class="avatar" />
            <div class="user-actions">
              <el-button class="password-btn submit-button" @click="openPasswordDialog">修改密码</el-button>
              <el-button class="logout-btn" @click="logout">退出登录</el-button>
            </div>
          </div>
        </div>
        <div class="content-container">
          <router-view v-slot="{ Component }">
            <keep-alive>
              <component :is="Component" />
            </keep-alive>
          </router-view>
        </div>
      </div>
      <password-dialog v-model="showPasswordDialog" />
    </div>

    <!-- 登录页面不显示布局 -->
    <router-view v-else></router-view>
  </div>
</template>

<script>
import PasswordDialog from '@/components/PasswordDialog';
import Message from '@/components/Message'; // 引入消息组件
import { Base64 } from 'js-base64';

export default {
  components: {
    PasswordDialog,
    Message // 注册消息组件
  },
  data() {
    return {
      showPasswordDialog: false,
      isCollapse: false, // 控制菜单栏是否折叠
      isMobile: false, // 是否为移动端
      isMenuHidden: false, // 移动端菜单是否隐藏（修改为默认显示）
      hasInitializedMobile: false, // 是否已初始化移动端状态
      navLinks: [
        { text: '系统配置', path: '/system-config'},
        { text: '概念板块', path: '/linkList' },
        { text: '板块概念', path: '/chip-concept'},
        { text: '新闻', path: '/news'},
        { text: '开盘数据', path: '/kpl' },
        { text: '个股信息', path: '/view-report' },
        { text: '文章试读', path: '/daily' },
        { text: '功能中心', path: '/tools-component'},
        { text: '7095报价', path: '/risky-search-form' },
        { text: '利润计算器', path: '/profitcalculator' },
        { text: '个股香草', path: '/stock-search-form' },
        { text: '个股雪球', path: '/stock-search-form-xq' },
        { text: '国君报价', path: '/knock-out' },
        { text: '无封顶气垫', path: '/uncapped-search-form' },
        { text: '查询记录', path: '/user-records'},
        { text: '中信中证持仓', path: '/zxzzcc' },
        { text: '订单查询', path: '/order' },
        { text: '期权备选', path: '/user_backup'},
        { text: '期权查询', path: '/option-search-form' },

        { text: '消息推送', path: '/message-push' },
        { text: '资金脉络', path: '/funds_flow' },
        { text: '游资分析', path: '/stock-analysis-chart' },
        { text: '涨停股票', path: '/child-component' },
        { text: '股票优选', path: '/first-buy' },
        { text: '财经要闻', path: '/article-list' },
        { text: '雪球新闻', path: '/xueqiu-news' },
        { text: '财联新闻', path: '/cls' },
        { text: '客户管理', path: '/customer-management' },
        { text: '用户管理', path: '/user-member' },
        { text: '菜单管理', path: '/menu-management' },
        { text: '用户组管理', path: '/group-management' },
        { text: '期权管理', path: '/option' },
        { text: '买卖规则', path: '/rules' },
        { text: '细分券池', path: '/segmented-search' },
        { text: '智能搜索', path: '/wc-search-form' },
      ]
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    encryptedNavLinks() {
      return this.navLinks.map(link => ({
        ...link,
        path: Base64.encode(link.path)
      }));
    }
  },
  methods: {
    async logout() {
      this.$store.dispatch('logout');
      this.$router.push('/');
      this.$message.success('退出成功');
    },
    openPasswordDialog() {
      this.showPasswordDialog = true;
    },
    decodePath(encodedPath) {
      return Base64.decode(encodedPath);
    },
    navigateTo(path) {
      this.$router.push(path);
      // 在移动端点击菜单项后隐藏菜单
      if (this.isMobile) {
        this.isMenuHidden = true;
      }
    },
    // 处理窗口大小变化
    handleResize() {
      // 获取当前屏幕宽度
      const screenWidth = document.body.clientWidth;
      // 判断是否为移动端
      this.isMobile = screenWidth < 768;
      // 在小屏幕上自动折叠菜单
      this.isCollapse = screenWidth < 768;
      // 在桌面端重置菜单隐藏状态
      if (!this.isMobile) {
        this.isMenuHidden = false;
        this.hasInitializedMobile = false;
      } else if (!this.hasInitializedMobile) {
        // 移动端初次加载时设置菜单隐藏状态
        this.isMenuHidden = true;
        this.hasInitializedMobile = true;
      }
    },
    // 切换移动端菜单显示状态
    toggleMenu() {
      this.isMenuHidden = !this.isMenuHidden;
    }
  },
  mounted() {
    // 组件挂载时检查屏幕大小
    this.handleResize();
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    // 组件卸载前移除事件监听
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>

<style scoped>
/* 主容器 */
.main-container {
  display: flex;
  min-height: 100vh;
  background: #f0f2f5;
}

/* 遮罩层 */
.menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: none;
}

.menu-overlay.show {
  display: block;
}

/* 菜单包装器 */
.menu-wrapper {
  position: relative;
  transition: transform 0.3s ease;
  z-index: 1000;
  background: #2c3e50;
}

/* 菜单切换按钮 */
.menu-toggle {
  position: absolute;
  top: 50%;
  right: -20px;
  transform: translateY(-50%);
  width: 24px;
  height: 60px;
  background: #2c3e50;
  border-radius: 0 4px 4px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 100;
  color: #ecf0f1;
  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.2);
}

/* 左侧菜单栏 */
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}

/* 左侧菜单栏 - 增强样式优先级 */
.menu-wrapper .el-menu-vertical-demo.custom-menu {
  width: 240px !important;
  min-height: 400px;
  background-color: #2c3e50 !important;
  border-right: none !important;
}

/* 菜单项基础样式 - 使用更具体的选择器 */
.menu-wrapper .el-menu-vertical-demo.custom-menu .el-menu-item.custom-menu-item {
  width: 100%;
  color: #ecf0f1 !important; /* 强制设置文字颜色 */
  background-color: transparent !important;
  transition: all 0.3s ease !important;
  padding: 12px 20px !important;
  border: none !important;
  margin: 0 !important;
}

/* 菜单项文字样式 - 直接针对文字元素 */
.menu-wrapper .el-menu-vertical-demo.custom-menu .el-menu-item.custom-menu-item .menu-text {
  color: #ecf0f1 !important;
  font-size: 14px;
}

/* 菜单项悬停样式 */
.menu-wrapper .el-menu-vertical-demo.custom-menu .el-menu-item.custom-menu-item:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

/* 菜单项悬停文字样式 */
.menu-wrapper .el-menu-vertical-demo.custom-menu .el-menu-item.custom-menu-item:hover .menu-text {
  color: #ffd04b !important;
}

/* 活动菜单项样式 */
.menu-wrapper .el-menu-vertical-demo.custom-menu .el-menu-item.custom-menu-item.is-active {
  background-color: rgba(255, 208, 75, 0.2) !important;
}

/* 活动菜单项文字样式 */
.menu-wrapper .el-menu-vertical-demo.custom-menu .el-menu-item.custom-menu-item.is-active .menu-text {
  color: #ffd04b !important;
}

/* 右侧内容区域 */
.right-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0px;
}

/* 内容头部 */
.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  background: #f8f9fa;
  border: 1px solid #ebeef5;
  padding: 10px 15px;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.user-info {
  display: flex;
  align-items: center;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 16px;
}

.user-actions {
  display: flex;
  flex-direction: row;
  gap: 8px;
}

.password-btn {
  background: rgba(231, 76, 60, 0.9);
  border: none;
  color: #fff;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.password-btn:hover {
  background: rgba(231, 76, 60, 1);
}

.logout-btn {
  background: rgba(231, 76, 60, 0.9);
  border: none;
  color: #fff;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.logout-btn:hover {
  background: rgba(231, 76, 60, 1);
}

/* 内容容器 */
.content-container {
  flex: 1;
  padding: 24px;
  background: #fff;
  min-height: 0;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  margin: 5px 10px 0px 10px;
}

/* 移动端菜单按钮 - 固定位置 */
.mobile-menu-button {
  position: fixed;
  top: 10px;
  left: 10px;
  z-index: 1001;
  width: 40px;
  height: 40px;
  background: #2c3e50;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.mobile-menu-button .menu-icon {
  color: #fff;
  font-size: 20px;
}

.mobile-menu-button:hover {
  background: #34495e;
  transform: scale(1.05);
}

/* 菜单包装器 */
.menu-wrapper {
  position: relative;
  transition: transform 0.3s ease;
  z-index: 1000;
  background: #2c3e50;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .main-container {
    position: relative;
  }

  /* 移动端菜单包装器 - 确保宽度固定且优先级最高 */
  .menu-wrapper {
    position: fixed !important;
    left: 0 !important;
    top: 0 !important;
    bottom: 0 !important;
    z-index: 1000 !important;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15) !important;
    background: #2c3e50 !important;
    width: 260px !important; /* 调整为更合适的宽度 */
    max-width: 90vw !important;
    overflow-y: auto !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  /* 移动端菜单 - 强制设置样式 */
  .menu-wrapper .el-menu-vertical-demo.custom-menu {
    width: 100% !important;
    height: 100% !important;
    min-height: 100vh !important;
    background-color: #2c3e50 !important;
  }

  /* 移动端菜单项 - 增强触摸体验 */
  .menu-wrapper .el-menu-vertical-demo.custom-menu .el-menu-item.custom-menu-item {
    width: 100% !important;
    padding: 16px 20px !important;
    font-size: 15px !important;
    line-height: 1.6 !important;
  }

  /* 移动端菜单项文字 - 确保清晰可见 */
  .menu-wrapper .el-menu-vertical-demo.custom-menu .el-menu-item.custom-menu-item .menu-text {
    color: #ecf0f1 !important;
    font-size: 15px !important;
    font-weight: 500 !important;
  }

  /* 移动端菜单项悬停效果 */
  .menu-wrapper .el-menu-vertical-demo.custom-menu .el-menu-item.custom-menu-item:hover {
    background-color: rgba(255, 208, 75, 0.2) !important;
  }

  /* 移动端菜单隐藏/显示动画 */
  .mobile-menu-hidden {
    transform: translateX(-100%) !important;
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  }

  .menu-wrapper:not(.mobile-menu-hidden) {
    transform: translateX(0) !important;
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  
  .el-menu-vertical-demo {
    height: 100%;
    min-height: 100vh;
  }

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    min-height: 100vh;
  }
  
  .el-menu-item {
    width: 100%;
    padding: 12px 20px;
    color: #fff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .el-menu-item:hover {
    background-color: #34495e;
  }

  .right-content {
    width: 100%;
    transition: all 0.3s ease;
  }

  /* 当菜单显示时，内容区域可以稍微调整 */
  .menu-wrapper:not(.mobile-menu-hidden) ~ .right-content {
    margin-left: 0;
  }
  
  .content-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }

  .user-info {
    width: 100%;
    justify-content: space-between;
  }

  .user-actions {
    flex-direction: row;
    gap: 8px;
  }

  .avatar {
    margin-right: 12px;
  }
}

@media (max-width: 480px) {
  .content-header {
    padding: 10px;
  }

  .user-actions {
    flex-direction: column;
    width: auto;
    gap: 5px;
  }

  .password-btn,
  .logout-btn {
    padding: 6px 12px;
    font-size: 12px;
  }

  .content-container {
    padding: 16px;
    margin: 5px 0 0 0;
  }
}

/* 新增：极小屏幕优化 */
@media (max-width: 360px) {
  .user-actions {
    flex-direction: column; /* 在极小屏幕上纵向排列 */
    gap: 5px;
  }

  .password-btn,
  .logout-btn {
    width: 100%;
    text-align: center;
  }
}

/* 确保菜单始终可见 */
.menu-wrapper {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
}

/* 确保移动端菜单按钮始终可见 */
.mobile-menu-button {
  display: flex !important;
  visibility: visible !important;
  opacity: 1 !important;
}

/* 确保菜单内容可见 */
.el-menu-vertical-demo.custom-menu .el-menu-item.custom-menu-item .menu-text {
  display: inline-block !important;
  visibility: visible !important;
  opacity: 1 !important;
}

/* 确保全局菜单样式优先级 */
.menu-wrapper .el-menu-vertical-demo.custom-menu {
  --el-menu-bg-color: #2c3e50 !important;
  --el-menu-text-color: #ecf0f1 !important;
  --el-menu-active-color: #ffd04b !important;
  --el-menu-hover-bg-color: rgba(255, 255, 255, 0.1) !important;
}

/* 移动端菜单项全局样式 */
@media (max-width: 768px) {
  .menu-wrapper .el-menu-vertical-demo.custom-menu .el-menu-item.custom-menu-item {
    --el-menu-item-height: 50px !important;
  }
}
</style>